import { UserSettingsLayout, type UserSettingsSection } from '@jarvis/platform-ui';
import './settingsLayout.css';

const SECTIONS: UserSettingsSection[] = [
  { id: 'general', text: 'General', path: 'general' },
  { id: 'my-apps', text: 'My Apps', path: 'my-apps' },
  { id: 'editors', text: 'Editors', path: 'editors' },
  { id: 'storage', text: 'Storage', path: 'storage' },
  { id: 'appearance', text: 'Appearance', path: 'appearance' },
  { id: 'support', text: 'Support', path: 'support' },
  { id: 'about', text: 'About', path: 'about' }
];

export function SettingsPage() {
  return (
    <div className="assistant-settings-page">
      <UserSettingsLayout sections={SECTIONS} />
    </div>
  );
}
